interface PVDocPreviewProps {
  scale?: number;
  className?: string;
}

// Stylized stand-in for a real proces-verbal photo. Used in the hero visual,
// preview cards, and OCR scanning screen. Matches `design-files/shared-ui.jsx`.
export function PVDocPreview({ scale = 1, className = '' }: PVDocPreviewProps) {
  const w = 200 * scale;
  const h = 264 * scale;
  return (
    <div
      style={{ width: w, height: h, padding: 14 * scale, fontSize: 7 * scale }}
      className={[
        'relative bg-card rounded-sm shadow-[0_18px_48px_rgba(0,0,0,0.18),0_2px_6px_rgba(0,0,0,0.08)] overflow-hidden font-mono leading-relaxed text-fg-2',
        className,
      ].join(' ')}
    >
      <div className="flex justify-between border-b border-line pb-1.5 mb-2">
        <span className="font-bold">POLIȚIA RUTIERĂ</span>
        <span>Seria PCA</span>
      </div>
      <div className="font-bold mb-2" style={{ fontSize: 9 * scale }}>
        PROCES-VERBAL DE CONSTATARE
      </div>
      {Array.from({ length: 14 }).map((_, i) => (
        <div
          key={i}
          style={{
            height: 2 * scale,
            width: `${60 + ((i * 7) % 40)}%`,
            marginBottom: 5 * scale,
          }}
          className="bg-[#e8e8e8] rounded-[1px]"
        />
      ))}
      <div
        style={{
          width: 50 * scale,
          height: 50 * scale,
          fontSize: 7 * scale,
          transform: 'rotate(-12deg)',
        }}
        className="absolute bottom-3.5 right-3.5 border-[1.5px] border-danger rounded-full flex items-center justify-center text-danger font-bold text-center leading-none"
      >
        ARTICOLUL
        <br />
        102
      </div>
    </div>
  );
}
